"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowCnftPerpetual = void 0;
const constants_1 = require("../../../../constants");
const constants_2 = require("../../../../constants");
const types_1 = require("../../../../types");
const offer_1 = require("../../offer");
const helpers_1 = require("./../../../../helpers");
const anchor_1 = require("@project-serum/anchor");
const borrowCnftPerpetual = ({ programId, connection, args, addComputeUnits, accounts, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_2.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const randomSeedForAccounts = Math.floor(Math.random() * 10000);
    const [fbond, fraktBondBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.FRAKT_BOND_PREFIX),
        accounts.nftMint.toBuffer(),
        accounts.bondOfferV2.toBuffer(),
        constants_1.ENCODER.encode(randomSeedForAccounts.toString()),
        constants_1.ENCODER.encode(args.amountOfSolToGet.toString()),
    ], program.programId);
    const [bondTradeTransactionV2, bondTradeTransactionBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_2.AUTOCOMPOUND_DEPOSIT_PREFIX),
        fbond.toBuffer(),
        accounts.bondOfferV2.toBuffer(),
        constants_1.ENCODER.encode(randomSeedForAccounts.toString()),
        constants_1.ENCODER.encode(args.amountOfSolToGet.toString()),
    ], program.programId);
    const [bondOfferVault, bondOfferVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_OFFER_VAULT_PREFIX), accounts.bondOfferV2.toBuffer()], program.programId);
    const remainingAccounts = [
        {
            pubkey: accounts.hadoMarket,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: bondTradeTransactionV2,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: fbond,
            isSigner: false,
            isWritable: true,
        },
    ];
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: 6000 });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    // const accountsIntoInstruction = {
    //   user: accounts.userPubkey,
    //   mutualBondTradeTxnVault: mutualBondTradeTxnVault,
    //   protocolFeeReceiver: accounts.protocolFeeReceiver,
    //   instructions: web3.SYSVAR_INSTRUCTIONS_PUBKEY,
    //   authorizationRulesProgram: AUTHORIZATION_RULES_PROGRAM,
    //   tokenProgram: TOKEN_PROGRAM_ID,
    //   associatedTokenProgram: ASSOCIATED_PROGRAM_ID,
    //   systemProgram: web3.SystemProgram.programId,
    //   rent: web3.SYSVAR_RENT_PUBKEY,
    //   metadataProgram: METADATA_PROGRAM_PUBKEY,
    // };
    const [treeAuthority, _bump2] = anchor_1.web3.PublicKey.findProgramAddressSync([accounts.tree.toBuffer()], constants_1.BUBBLEGUM_PROGRAM_ID);
    const [sponsorVault, sponsorVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.PERPETUAL_SPONSOR_VAULT)], program.programId);
    const [hadoMarketValidation, hadoMarketValidationBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.HADOMARKET_VALIDATION_PREFIX), accounts.hadoMarket.toBuffer()], program.programId);
    const proofPathAsAccounts = (0, helpers_1.mapProof)(args.proof);
    const root = (0, helpers_1.decode)(args.proof.root);
    const dataHash = (0, helpers_1.decode)(args.cnftParams.dataHash);
    const creatorHash = (0, helpers_1.decode)(args.cnftParams.creatorHash);
    const nonce = new anchor_1.BN(args.cnftParams.leafId);
    const index = args.cnftParams.leafId;
    instructions.push(yield program.methods
        .borrowCnftPerpetual({
        minAmountToGet: new anchor_1.BN(randomSeedForAccounts),
        amountOfSolToGet: new anchor_1.BN(args.amountOfSolToGet),
        bondTradeTransactionBump: bondTradeTransactionBump,
        fraktBondBump: fraktBondBump,
        bondOfferVaultBump: bondOfferVaultBump,
    }, root, dataHash, creatorHash, nonce, index, proofPathAsAccounts.length, args.optimizeIntoReserves, new anchor_1.BN(args.aprRate))
        .accountsStrict({
        user: accounts.userPubkey,
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        protocolFeeReceiver: accounts.protocolFeeReceiver,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        whitelistEntry: accounts.whitelistEntry,
        merkleTree: accounts.tree,
        treeAuthority: treeAuthority,
        bubblegumProgram: constants_1.BUBBLEGUM_PROGRAM_ID,
        compressionProgram: constants_1.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
        logWrapper: constants_1.SPL_NOOP_PROGRAM_ID,
        nftMint: accounts.nftMint,
        sponsorVault: sponsorVault,
        bondOfferVault: bondOfferVault,
        bondOffer: accounts.bondOfferV2,
        hadoMarketValidation,
    })
        .remainingAccounts([...remainingAccounts, ...proofPathAsAccounts])
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    let inputFee = (0, offer_1.checkIsHadomarketSponsored)(accounts.hadoMarket.toBase58()) ? false : true;
    const protocolFeeAmount = inputFee ? (args.amountOfSolToGet * constants_1.PROTOCOL_FEE) / constants_1.BASE_POINTS : 0;
    const borrowedAmountWithoutFee = args.amountOfSolToGet - protocolFeeAmount;
    const newBond = {
        fraktBondState: types_1.FraktBondState.PerpetualActive,
        bondTradeTransactionsCounter: 0,
        borrowedAmount: borrowedAmountWithoutFee,
        banxStake: '11111111111111111111111111111111',
        fraktMarket: args.optimistic.fraktMarket,
        amountToReturn: 0,
        actualReturnedAmount: 0,
        terminatedCounter: 0,
        fbondTokenMint: accounts.nftMint.toBase58(),
        fbondTokenSupply: 0,
        activatedAt: (0, offer_1.nowInSeconds)(),
        liquidatingAt: 0,
        fbondIssuer: accounts.userPubkey.toBase58(),
        repaidOrLiquidatedAt: 0,
        currentPerpetualBorrowed: args.amountOfSolToGet,
        lastTransactedAt: (0, offer_1.nowInSeconds)(),
        refinanceAuctionStartedAt: 0,
        hadoMarket: accounts.hadoMarket.toBase58(),
        publicKey: fbond.toBase58(),
    };
    const optimisticResult = (0, offer_1.optimisticBorrowPerpetual)({
        fraktBond: newBond,
        bondTradeTransaction: bondTradeTransactionV2.toBase58(),
        bondOffer: args.optimistic.bondOffer,
        userPubkey: accounts.userPubkey.toBase58(),
        amountOfSolToGet: args.amountOfSolToGet,
        minMarketFee: args.aprRate,
        inputFee,
        isRefinance: false,
        isBorrower: true,
        optimizeIntoReserves: args.optimizeIntoReserves,
        redeemResult: types_1.RedeemResult.DirectBorrow,
        borrowerOriginalLent: 0,
        borrowerFullRepaidAmount: 0
    });
    return {
        instructions,
        signers,
        optimisticResults: [optimisticResult],
    };
});
exports.borrowCnftPerpetual = borrowCnftPerpetual;
